export const th = {
  msg:
    {
      'username': 'ช่ือผู้ใช้',
      'password': 'รหัสผ่าน',
      'login': 'Login',
      'username_not_found': 'Please enter your Username',
      'password_not_found': 'Please enter your Password',
      'error': 'Invalid username or password',
      'changeLanguage': '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      'submit_button_text': 'Submit',
      'enter': 'เอนเตอร์',
      'en': 'English',
      'ms': 'Bahasa Melayu',
      'zh': 'Chinese',
      'ta': 'Tamil',
      'km': 'Khmer',
      'th': 'Thai',
      'id': 'Bahasa Indonesia',
      'ar': 'Arabic',
      'blank_username_field': 'Please enter your username.',
      'blank_password_field': 'Please enter your password.',
      'invalid_credentials': 'Invalid username or password.',
      'copyright': 'ขับเคลื่อนโดย Global Psytech'
    }
}
